import { render } from "./LetterCreate.vue?vue&type=template&id=c2f03934"
import script from "./LetterCreate.vue?vue&type=script&lang=js"
export * from "./LetterCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__